/**
 * Enum que define los tipos de modal de uso genérico.
 */
export enum ModalTipoEnum {
  GUARDAR = 'Guardar',
  RESTAURAR = 'Restaurar',
  SALIR = 'Salir',
  AGREGAR_INDIVIDUAL = 'AgregarIndividual',
  AGREGAR_MASIVO = 'AgregarMasivo',
  EDITAR = 'Editar',
  ELIMINAR = 'Eliminar',
  CONFIRMAR_SALIDA_EDITAR = 'SalirEditar',
  ELIMINAR_DOCUMENTO = 'EliminarDocumento',
}
